import refs from '../helpers/refs'

class CDescriptionBoxNoFeatures {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-description-box-no-features')
    .forEach(el => new CDescriptionBoxNoFeatures(el))
})
